__turbopack_context__.v({
  "app_light_theme": "total-drawer-content-module-scss-module__Tr91Wq__app_light_theme",
  "totalDrawerContent": "total-drawer-content-module-scss-module__Tr91Wq__totalDrawerContent",
  "totalDrawerContent--overlay": "total-drawer-content-module-scss-module__Tr91Wq__totalDrawerContent--overlay",
  "totalDrawerContent--visible": "total-drawer-content-module-scss-module__Tr91Wq__totalDrawerContent--visible",
  "totalDrawerContent__button": "total-drawer-content-module-scss-module__Tr91Wq__totalDrawerContent__button",
  "totalDrawerContent__closeButton": "total-drawer-content-module-scss-module__Tr91Wq__totalDrawerContent__closeButton",
});
